export enum SearchPersonalFiltersFilterValue {
  MY_IMAGES = "my_images",
  MY_LIKES = "my_likes",
  MY_BOOKMARKS = "my_bookmarks",
  MY_FOLLOWED_USERS = "my_followed_users"
}
